<!-- CustomInput.vue -->
<template>
  <div class="xh-mark-bolck-list" v-show="showDrop">
    <ul>
      <li
        class="xh-mark-bolck-list-item"
        v-for="(item, index) in typeList"
        :key="index"
        @click="onclickItem(item)"
      >
        <div class="content-box" v-if="item.type !== 'custom'">
          <img :src="item.icon" />
          <div>{{ item.title }}</div>
        </div>
        <el-popover
          v-else
          popper-class="xh-mark-bolck-input-popover"
          placement="right"
          :visible-arrow="false"
          trigger="click"
          v-model="visible"
        >
          <div class="xh-mark-bolck-input" ref="inputArea">
            <div class="title">
              <span>自定义标记</span>
              <img :src="CloseIcon" @click="onclickClose" alt="" />
            </div>
            <div class="input-area">
              <div class="input-box">
                <el-input
                  v-model="inputValue"
                  placeholder="请填写标记内容"
                  :maxlength="maxLength"
                />
                <span class="count-box">
                  <span>{{ inputValue.length }}</span> /
                  <span>{{ maxLength }}</span>
                </span>
              </div>
              <button :class="{ disabled: !inputValue }" @click="save">
                保存
              </button>
            </div>
          </div>
          <div slot="reference" class="content-box">
            <img :src="item.icon" />
            <div>{{ item.title }}</div>
          </div>
        </el-popover>
      </li>
    </ul>
  </div>
</template>

<script>
import CloseIcon from "@saas/components/assets/images/wang-editor/close.png";
import CustomIcon from "@saas/components/assets/images/wang-editor/custom-note.png";
import QuestionIcon from "@saas/components/assets/images/wang-editor/question-note.png";
import keyIcon from "@saas/components/assets/images/wang-editor/key-note.png";
export default {
  props: {
    editor: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showDrop: true,
      inputValue: "",
      CustomIcon: CustomIcon,
      QuestionIcon: QuestionIcon,
      keyIcon: keyIcon,
      CloseIcon: CloseIcon,
      typeList: [
        {
          type: "key",
          icon: keyIcon,
          title: "重点",
        },
        {
          type: "question",
          icon: QuestionIcon,
          title: "疑问点",
        },
        {
          type: "custom",
          icon: CustomIcon,
          title: "自定义",
        },
      ],
      visible: false,
    };
  },
  computed: {
    maxLength: () => 10,
  },
  mounted() {
    this.editor.on("showMarkDrop", () => {
      this.showDrop = true;
      this.inputValue = "";
      this.visible = false;
    });
  },
  beforeDestroy() {
    console.log("destory");
  },
  methods: {
    onclickItem(item) {
      if (item.type === "custom") {
        this.visible = true;
        this.inputValue = "";
      } else {
        this.editor.emit("xhEmitInsertMarkBlock", {
          type: item.type,
          content: item.title,
        });
        this.showDrop = false;
      }
    },
    onclickClose() {
      this.inputValue = "";
      this.visible = false;
    },
    save() {
      if (!this.inputValue) {
        return;
      }
      this.editor.emit("xhEmitInsertMarkBlock", {
        type: "custom",
        content: this.inputValue,
      });
      this.inputValue = "";
      this.visible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.xh-mark-bolck-list {
  width: 94px;
  height: 104px;
  background: #14171c;
  border-radius: 12px;
  min-width: 94px;
  padding: 10px 12px;
}
ul {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
}
li {
  cursor: pointer;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  line-height: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .content-box {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  img {
    margin-right: 6px;
    width: 20px;
    height: 20px;
  }
}
.xh-mark-bolck-input {
  width: 284px;
  height: 62px;
  background: var(--wang-editor-modal-bg, #ffffff);
  border-radius: 6px;
  border: 1px solid var(--wang-editor-modal-border, #f2f3f5);
  .title {
    height: 20px;
    width: 100%;
    padding: 4px 4px 0 8px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    span {
      font-weight: 400;
      font-size: 12px;
      color: var(--wang-editor-modal-title, #0d1400);
    }
    img {
      width: 20px;
      height: 20px;
      cursor: pointer;
      filter: var(--wang-editor-modal-icon-filter, none);
    }
  }
  .input-area {
    padding: 6px 10px 6px 6px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .input-box {
      width: 209px;
      height: 28px;
      background: var(--wang-editor-modal-input-bg, #ffffff);
      border-radius: 6px;
      border: 1px solid var(--wang-editor-modal-input-border, #f2f3f5);
      display: flex;
      flex-direction: row;
      align-items: center;
      .el-input ::v-deep {
        border: none;
        height: 100%;
        flex: 1;
        .el-input__inner {
          height: 100%;
          border: none;
          padding: 0 4px;
          background: transparent;
          color: var(--wang-editor-modal-title, #0d1400);
          &::placeholder {
            color: var(--wang-editor-modal-placeholder, #909399);
          }
        }
      }
      .count-box {
        width: 50px;
        font-size: 12px;
        color: var(--wang-editor-modal-placeholder, #c9cdd4);
        display: flex;
        align-items: center;
        justify-content: space-between;
        span {
          flex: 1;
          text-align: center;
        }
      }
      span {
      }
    }
    button {
      width: 54px;
      height: 28px;
      background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
      border-radius: 6px;
      font-weight: 500;
      font-size: 12px;
      color: #ffffff;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      &.disabled {
        background: var(--wang-editor-modal-input-bg, #ffffff);
        color: var(--wang-editor-modal-placeholder, #c9cdd4);
        cursor: not-allowed;
        border: 1px solid var(--wang-editor-modal-input-border, #f2f3f5);
      }
    }
  }
}
</style>
<style>
.xh-mark-bolck-input-popover {
  --wang-editor-modal-bg: #ffffff;
  --wang-editor-modal-border: #e5e6e8;
  --wang-editor-modal-title: #0d1400;
  --wang-editor-modal-input-bg: #ffffff;
  --wang-editor-modal-input-border: #f2f3f5;
  --wang-editor-modal-placeholder: #909399;
  --wang-editor-modal-icon-filter: none;
  padding: 0;
  border: unset;
  background: transparent;
}
html.dark .xh-mark-bolck-input-popover,
html.theme-dark .xh-mark-bolck-input-popover,
html[data-theme="dark"] .xh-mark-bolck-input-popover {
  --wang-editor-modal-bg: var(--mg-bg-elevated, #17243a);
  --wang-editor-modal-border: var(--mg-border-subtle, rgba(148, 163, 184, 0.2));
  --wang-editor-modal-title: var(--mg-text-primary, #f8fafc);
  --wang-editor-modal-input-bg: var(--mg-control-bg, #111827);
  --wang-editor-modal-input-border: var(--mg-border-subtle, rgba(148, 163, 184, 0.2));
  --wang-editor-modal-placeholder: var(--mg-text-muted, #94a3b8);
  --wang-editor-modal-icon-filter: invert(1);
}
</style>
